import { render } from "./classifyCreat.vue?vue&type=template&id=e8f088ce&scoped=true"
import script from "./classifyCreat.vue?vue&type=script&lang=js"
export * from "./classifyCreat.vue?vue&type=script&lang=js"

import "./classifyCreat.vue?vue&type=style&index=0&id=e8f088ce&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e8f088ce"]])

export default __exports__